export const businessActionStyles = {
  selectedBusinessCard: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    position: "relative",
    cursor: "pointer",
  },
  selectedBusinessImage: {
    width: 100,
    height: 100,
    borderRadius: "8px",
  },
  businessName: {
    fontSize: "17px",
    fontWeight: "600",
    color: "#000",
    width: "90%",
  },
  businessAddress: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#000",
  },
  binButton: { position: "absolute", top: 0, right: 0 },
};
